import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HSeparatorDirective } from '@core/directives/h-separator.directive';
import { DecimalInputDirective } from './decimal-input.directive';
import { CustomPopoverDirective } from './popover/custom-popover.directive';
import { CustomTooltipComponent } from './popover/custom-tooltip/custom-tooltip.component';
import { RealThousandsSeparatorDirective } from './real-thousands-separator.directive';
import { ThousandsSeparatorsDirective } from './thousands-separators.directive';
import { TimeMaskDirective } from './time-mask.directive';

@NgModule({
  declarations: [
    TimeMaskDirective,
    ThousandsSeparatorsDirective,
    RealThousandsSeparatorDirective,
    CustomTooltipComponent,
    CustomPopoverDirective,
    HSeparatorDirective,
  ],
  imports: [CommonModule, OverlayModule, DecimalInputDirective],
  exports: [
    TimeMaskDirective,
    ThousandsSeparatorsDirective,
    RealThousandsSeparatorDirective,
    DecimalInputDirective,
    CustomPopoverDirective,
    CustomTooltipComponent,
    OverlayModule,
    HSeparatorDirective,
  ],
})
export class DirectivesModule {}
